module.exports = __webpack_public_path__ + "img/33.5.COD.8f1d4d7c.png";